<template>

	<div>
		<div class="container-box">
			<div class="headers">
				<tabBar class="tabBarStyle"></tabBar>
			</div>
		</div>
		<div class="msg-all-contain" style="margin-top: 7.5vh;padding-bottom: 80px;">

			<div class="msg-board">
				<div class="msg-board-contain">

					<div class="msg-content">
						<comments-child v-if="comments.length > 0" :comments="comments"
							:count="layerCount"></comments-child>
						<div v-else>
							<img src="../../assets/zyly.jpg" style="height: 100%; width: 100%;" />
							<div
								style="width: 100%; text-align: center; color: rgb(181 181 181); font-size: 20px; font-weight: 600;">
								暂无留言</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="msg-head">
			<img v-if="userAvatar" :src="userAvatar" alt="" />
			<img v-else :src="require('@/assets/default.jpg')" alt="" />
			<textarea type="textarea" :class="inputStatusClass" placeholder="请输入您的留言" ref="input" v-model="newComment"
				cols="60" rows="5">
			</textarea>
			<button @click="submit" style="height: 52px;">提交</button>
		</div>
		<fixedBottomRight></fixedBottomRight>
	</div>
</template>

<script>
	import CommentsChild from "./CommentsChild";
	import tabBar from "../../assembly/tabBarNew.vue";
	import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
	import {
		getMessage,
		saveMessage
	} from "../../api/home.js";
	export default {
		name: "commentsMessage",
		data() {
			return {
				// 评论列表
				comments: [],
				// 新评论
				newComment: "",
				// 用户头像
				userAvatar: "",
				// 非空判断
				hasNoConent: false,
				// 输入栏状态
				inputStatusClass: "",
				// 计数
				layerCount: 0,
			};
		},
		created() {},
		mounted() {
			this.initData();
		},
		components: {
			"comments-child": CommentsChild,
			tabBar,
			fixedBottomRight
		},
		methods: {
			// 提交
			submit() {
				var self = this;
				// 提交信息非空验证
				if (!self.newComment || self.newComment === "") {
					self.hasNoConent = true;
					self.inputStatusClass = "no-content-warn";
					return;
				}
				self.inputStatusClass = "";

				// 生成comment对象
				var comment = {
					// 父评论Id
					parentId: "",
					// 评论内容
					text: self.newComment,
					// 发送者id
					senderId: "1",
					// 接收者id
					receiverId: "",
					// 发送时间
					postDate: "",
					// 发送者头像
					senderAvatar: "",
					// 子评论
					children: [],
					// 发送者姓名
					senderName: "匿名用户",
					// comment id
					id: "",
					// 点赞
					likes: 0
				};
				const sysMessage = {
					senderName: "匿名用户",
					messageParentid: "0",
					message: self.newComment
				};
				saveMessage(sysMessage).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '提交成功，审核后可见！',
							type: 'success',
							offset: window.screen.height / 2
						});
					}
				})
				// 新添加的评论插入数组最前面
				/* self.comments.unshift(comment); */
				// 清空评论内容
				self.newComment = "";
			},
			initData() {
				var self = this;
				self.getComments();
			},
			// 获取数据
			getComments() {
				var self = this;
				getMessage().then((res) => {
					if (res.code == 200 && res.data.length > 0) {
						console.log(res.data)
						self.comments = res.data;
					}
				})

				// 这是自己伪造的数据
				// 要根据接口要求进行修改
				/* self.comments = [{
					children: [{
						parentId: "55824b1c",
						text: "回复信息",
						senderId: "25d85a0f",
						receiverId: "25d85a0f",
						postDate: "2022-08-05 12:10",
						senderAvatar: "",
						children: [],
						senderName: "默认昵称",
						id: "f0e3a81b",
						likes: 0,
						receiverName: "Irene",
						receiverAvatar: "",
					}, ],
					id: "55824b1c",
					postDate: "2022-08-05 8:09",
					senderName: "默认昵称",
					senderAvatar: "",
					receiverName: null,
					receiverAvatar: null,
					parentId: null,
					text: "测试信息",
					senderId: "25d85a0f",
					receiverId: null,
					likes: 0,
				}, ]; */
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container-box {
		display: flex;
		flex-direction: column;


	}

	.headers {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: fixed;
		background-color: #840000;
		height: 7.5vh;
		width: 100%;
		z-index: 999;
		opacity: 0.85;
	}



	/* 评论头像 */
	.msg-head img {
		width: 55px;
		height: 55px;
		border-radius: 50%;
		position: absolute;
		top: 22px;
		left: 13px;
	}

	.msg-all-contain {
		width: 100%;
		height: 100%;
		overflow-y: auto;


	}

	.msg-board-contain {
		letter-spacing: 1px;
		padding: 0 10px;
	}

	/* 信息栏标题 */
	.msg-board-title {
		width: auto;
		text-align: center;
		font-size: 28px;
		font-weight: 300;
		margin: 0 0 1.8rem 0;
		min-height: 20px;
		color: #000 !important;
		font-family: "Lato", Verdana, sans-serif !important;
	}

	.msg-head {
		background-color: rgb(248, 248, 248);
		position: fixed;
		height: 80px;
		border-radius: 5px;
		bottom: 0px;
		width: 100%;
	}

	/* 评论输入 */
	.msg-head textarea {
		position: absolute;
		top: 13px;
		left: 85px;
		max-height: 60px;
		border-radius: 5px;
		outline: none;
		width: calc(100% - 180px);
		font-size: 16px;
		padding: 20px;
		border: 2px solid #f8f8f8;
		resize: none;
	}

	/* 发布评论按钮 */
	.msg-head button {
		position: absolute;
		top: 13px;
		right: 35px;
		width: 100px;
		height: 100px;
		border: 0;
		border-radius: 5px;
		font-size: 18px;
		font-weight: 500;
		color: #fff !important;
		background-color: #00a1d6;
		transition: 0.1s;
		cursor: pointer;
		letter-spacing: 2px;
	}

	/* 鼠标经过字体加粗 */
	.msg-head button:hover {
		/*font-weight: 600;*/
	}

	.msg-content {
		overflow-y: auto;
	}

	/* 评论内容区域 */
	.msg-content .child-comment {
		display: flex;
		position: relative;
		padding: 18px 10px 18px 10px;
	}

	@media (max-width: 900px) {
		.msg-head img {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			position: absolute;
			top: 22px;
			left: 13px;
		}

		.msg-head textarea {
			position: absolute;
			top: 13px;
			left: 70px;
			height: 55px;
			border-radius: 5px;
			outline: none;
			width: calc(100% - 200px);
			font-size: 15px;
			padding: 10px;
			border: 2px solid #f8f8f8;
			resize: none;
		}

		.msg-head button {
			position: absolute;
			top: 13px;
			right: 16px;
			width: 80px;
			height: 77px;
			border: 0;
			border-radius: 5px;
			font-size: 14px;
			font-weight: 500;
			color: #fff !important;
			background-color: #00a1d6;
			transition: 0.1s;
			cursor: pointer;
			letter-spacing: 2px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/iphone/message.vue